<template>
  <div class="tw-space-y-3">
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
      <h2 v-if="isShowTitle" class="tw-text-base sm:tw-text-lg tw-font-semibold tw-text-slate-900">Vessel Tracking</h2>
    </div>

    <div class="
      tw-relative
      tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white/60 tw-shadow-sm
    ">
      <a
        class="tw-absolute tw-top-0 tw-left-0
          tw-inline-flex tw-items-center tw-justify-center tw-gap-2 
          tw-rounded-lg tw-border tw-border-slate-200 
          tw-bg-white/100  hover:tw-bg-grey
          tw-px-1 tw-py-1
          tw-text-sm tw-font-medium tw-text-slate-800 
          tw-transition tw-duration-150
          "
        :href="vesselTrackerExternalUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        Track on VesselFinder.com (MMSI {{ (this as any).mssi }})
      </a>
      <iframe
        name="vesselfinder"
        id="vesselfinder"
        class="tw-block tw-w-full"
        :style="{ height: computedHeight }"
        frameborder="0"
        :src="vesselTrackerUrl"
      ></iframe>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    mssi: {
      required: true,
    },
    width: {
      default: 800,
    },
    height: {
      default: '400',
    },
    // 
    isShowTitle: {
      default: true,
    },
    // if we are embedding this component in a parent (like a modal) 
    // that wants to control the dimensions
    isFitParentDimensions: {
      default: false,
    },
  },
  computed: {
    computedHeight(): string {
      if (this.isFitParentDimensions) {
        return '100%';
      }
      const h = Number((this as any).height);
      if (!Number.isFinite(h) || h <= 0) return '520px';
      return Math.max(320, Math.min(720, h)) + 'px';
    },
    vesselTrackerUrl(): string {
      const urlBase = `https://www.vesselfinder.com/aismap?`
      const params = {
        zoom: 'undefined',
        lat: 'undefined',
        lon: 'undefined',
        width: '100%',
        height: (this as any).computedHeight,
        names: 'true',
        mmsi: (this as any).mssi,
        track: 'true',
        fleet: 'false',
        fleet_name: 'false',
        fleet_hide_old_positions: 'false',
        clicktoact: 'false',
        store_pos: 'true',
        ra: process.env.VUE_APP_SERVER_URL,
      };
      const urlParams = new URLSearchParams(params);
      
      return `${urlBase}${urlParams.toString()}`;
    },
    vesselTrackerExternalUrl(): string {
      return `https://www.vesselfinder.com/?mmsi=${(this as any).mssi}`;
    },
  },
});
</script>